import { render, staticRenderFns } from "./KEditPhoto.vue?vue&type=template&id=c4a872f6&scoped=true"
import script from "./KEditPhoto.vue?vue&type=script&lang=js"
export * from "./KEditPhoto.vue?vue&type=script&lang=js"
import style0 from "./KEditPhoto.vue?vue&type=style&index=0&id=c4a872f6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a872f6",
  null
  
)

export default component.exports